/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_adapter",
                type: "address",
                internalType: "contract BaseALMAdapter",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "adapter",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract BaseALMAdapter",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getPoolData",
        inputs: [
            {
                name: "vault",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct ALMLeverageDataProvider.ALMPoolData",
                components: [
                    {
                        name: "token0",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "token1",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "total0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "total1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getPositionData",
        inputs: [
            {
                name: "_position",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "tuple",
                internalType: "struct ALMLeverageDataProvider.ALMLeveragedPositionData",
                components: [
                    {
                        name: "token0",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "token1",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "vault",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "shares",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "debtAsset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "debt",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getPositionsData",
        inputs: [
            {
                name: "positions",
                type: "address[]",
                internalType: "address[]",
            },
        ],
        outputs: [
            {
                name: "datas",
                type: "tuple[]",
                internalType: "struct ALMLeverageDataProvider.ALMLeveragedPositionData[]",
                components: [
                    {
                        name: "token0",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "token1",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "vault",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "shares",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount0",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount1",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "debtAsset",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "debt",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        stateMutability: "view",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ALMLeverageDataProvider__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_adapter, overrides) {
        return super.deploy(_adapter, overrides || {});
    }
    getDeployTransaction(_adapter, overrides) {
        return super.getDeployTransaction(_adapter, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
ALMLeverageDataProvider__factory.bytecode = _bytecode;
ALMLeverageDataProvider__factory.abi = _abi;
//# sourceMappingURL=ALMLeverageDataProvider__factory.js.map